<template>
  <section class="add-event">
    <h3 class="add-event__title">
      {{ $t('CP.addEvent') }}
    </h3>
    <div class="image-and-form">
      <image-upload
        @loadStart="imageUrl = null"
        @loadImage="loadEventImage"
        @imageError="handleError"
        :value="imageUrl"
        size="43px"
      />
      <form class="add-event-form" @submit.stop.prevent="handleSubmit">
        <app-input-small
          :error="touched && eventError"
          :label="$t('CP.eventName')"
          v-model="nameEvent"
          :focus-on-mount="true"
          style="width: 100%;"
        />
        <div
          :style="{ opacity: touched && eventError ? '1' : '0' }"
          class="error-message">
          {{ $t('validateText.eventNameRequired') }}
        </div>
<!--        <user-photo-list-->
<!--          @changeParticipants="changeParticipants"-->
<!--          :label="$t('CP.eventParticipants')"-->
<!--          class="user-photo-list"-->
<!--          :users="finalUserSelectedContacts"-->
<!--        />-->
      </form>
    </div>
    <user-contact-participants-form
      class="participants-form"
      title=""
      lock-user-deletion
      @toggleAddParticipants="toggleAddParticipants"
    />
    <div
      v-if="imageErrorMessage"
      class="form__error-message">
        {{ imageErrorMessage }}
    </div>
    <div
      v-if="touched && hasUserThisQuasiEvent"
      class="form__error-message">
        {{ $t('validateText.quasiEventAlreadyExists') }}
    </div>
    <div class="form-buttons">
      <button-app
        class="form-button_cancel"
        color-scheme="gray"
        type="submit"
        @clicked="cancelEventSubmit"
      >
        {{ $t('CP.cancel') }}
      </button-app>
      <button-app
        class="form-button_save"
        type="button"
        @clicked="handleSubmit"
      >
        {{ $t('CP.create') }}
      </button-app>
    </div>
    <transition name="addEventFooter">
<!--        v-if="touched && eventError"-->
      <footer
        class="add-event__footer">
        <img :src="require('../../assets/img/sharp-error.svg')" alt="sharp-error" class="img-sharp">
        <p class="text-info-reset-password">
          {{ $t('CP.toCreateQuasiEvent') }}
          {{ $t('CP.addUserAndDeleteImage')}}.
        </p>
      </footer>
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import {
  ADD_EVENT_REQUEST,
  FETCH_EVENTS_REQUEST,
} from '@/store/events/types';
import {
  DELETE_FINAL_USER_SELECTED_CONTACTS,
  SET_USER_SELECTED_CONTACTS,
} from '@/store/user/types';
// import UserPhotoList from '../../components/UserPhotoList/UserPhotoList';
import { SET_CROPPER_INFO } from '@/store/operations/types';
import { productTours } from '@/plugins/shepherd';
import ImageUpload from '../../components/ImageUpload/ImageUpload';
import AppInputSmall from '../../components/AppInputSmall/AppInputSmall';
import ButtonApp from '../../components/Button/ButtonApp';
import UserContactParticipantsForm from '../UserContactParticipantsForm/UserContactParticipantsForm';
import functionsWithForms from '../../utils/mixins/functionsWithForms';

export default {
  name: 'AddEventForm',
  components: {
    UserContactParticipantsForm,
    ButtonApp,
    // UserPhotoList,
    AppInputSmall,
    ImageUpload,
  },
  extends: functionsWithForms,
  data() {
    return {
      nameEvent: '',
      imageUrl: null,
      inviteAll: false,
      touched: false,
      imageErrorMessage: '',
      participantsOpened: false,
      breakpointLg: window.matchMedia('(min-width: 1025px)'),
    };
  },
  mounted() {
    this.showTour();
  },
  watch: {
    cropperInfo(next) {
      if (next && next.destination) {
        this.imageUrl = next.destination;
      }
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      events: (state) => state.events.events,
      userPhone: (state) => state.user.user.phone,
      finalUserSelectedContacts: (state) => state.user.finalUserSelectedContacts,
      cropperInfo: (state) => state.operations.cropperInfo,
      areAllToursFinished: (state) => state.tour.areAllToursFinished,
      tourStates: (state) => state.tour.tourStates,
    }),
    eventError() {
      if (this.nameEvent) {
        return false;
      }
      if (!this.nameEvent && !this.imageUrl
        && this.finalUserSelectedContacts && this.finalUserSelectedContacts.length === 2) {
        return false;
      }
      return true;
    },
    hasUserThisQuasiEvent() {
      if (this.nameEvent || this.imageUrl) return false;
      const currentUserList = this.finalUserSelectedContacts
        .filter((user) => user.uid !== this.user.user);
      if (currentUserList.length !== 1) return false;
      const hasUserThisQuasiEvent = !!this.events.find((event) => {
        if (event.event_name) return false;
        const quasiUserList = event.contacts
          .filter((eventContact) => eventContact.uid !== this.user.user);
        if ((quasiUserList.length === 1)
          && (currentUserList[0].uid === quasiUserList[0].uid)
        ) return true;
        return false;
      });
      return hasUserThisQuasiEvent;
    },
  },
  methods: {
    handleError(message) {
      this.imageErrorMessage = message;
    },
    showTour() {
      if (!this.areAllToursFinished && !this.tourStates.createEvent && this.breakpointLg.matches) {
        setTimeout(() => {
          productTours[this.$i18n.locale].createEvent.start();
        }, 350);
      }
    },
    toggleAddParticipants() {
      this.participantsOpened = !this.participantsOpened;
    },
    changeParticipants() {
      this.$store.commit(SET_USER_SELECTED_CONTACTS, this.finalUserSelectedContacts);
      this.$bvModal.show('user-contact-participants');
    },
    cancelEventSubmit() {
      this.cancelSubmit(DELETE_FINAL_USER_SELECTED_CONTACTS, 'add-event');
    },
    async handleSubmit() {
      this.touched = true;
      if (this.eventError || this.imageErrorMessage) {
        return;
      }
      if (this.hasUserThisQuasiEvent) {
        return;
      }
      const {
        nameEvent, inviteAll, finalUserSelectedContacts,
      } = this;
      const contacts = [];
      let imageUrl = '';
      if (this.imageUrl) {
        // eslint-disable-next-line prefer-destructuring
        imageUrl = this.imageUrl.split('base64,')[1];
      }
      // contacts.push({ phone: this.userPhone });
      finalUserSelectedContacts.forEach((contact) => {
        contacts.push({ phone: contact.phone });
      });
      const newEvent = await this.$store.dispatch(ADD_EVENT_REQUEST, {
        event_name: nameEvent,
        contacts,
        image_url: imageUrl,
        invite_all: inviteAll,
      });
      this.$store.commit(DELETE_FINAL_USER_SELECTED_CONTACTS);
      this.$store.dispatch(FETCH_EVENTS_REQUEST);
      this.$bvModal.hide('add-event');
      if (newEvent && newEvent.id) {
        await this.$router.push(`/events/${newEvent.id}/transactions`);
      }
    },
    loadEventImage(file) {
      this.loadImage(file, SET_CROPPER_INFO);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "AddEventFooterTransition";
  .add-event__title {
    color: var(--text-main-color);
    margin: 0 0 26px;
  }
  .image-and-form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .add-event-form {
    display: flex;
    flex-wrap: wrap;
  }
  .user-photo-list {
    flex: 1 0 100%;
    font-size: 1rem;
    color: var(--text-main-color);
    margin: 20px 0 32px;
  }
  .participants-form {
    padding: 12px;
    margin: 12px 0;
    border: 1px solid var(--gray-lighten);
    border-radius: 5px;
  }
  .form__error-message {
    margin: 0 auto 14px 0;
    font-size: 1rem;
    color: var(--error-red);
    display: flex;
    align-items: flex-end;
  }
  .form-buttons {
    display: flex;
    justify-content: center;
  }
  .form-button_cancel {
    width: 160px;
    margin: 0 8px 0 0;
  }
  .form-button_save {
    margin: 0;
    width: 160px;
    height: 38px;
  }
  .error-message {
    flex: 1 0 100%;
    color: var(--error-red);
    font-size: 13px;
  }
  .add-event__footer {
    display: flex;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 84px;
    align-items: center;
    padding: 0 20px;
    background-color: #48528C;
    /*border-radius: 8px;*/
    /*margin-top: 20px;*/
    margin: 20px -32px;
    border-radius: 0 0 0.3rem 0.3rem;
    /*border-bottom-left-radius: 8px;*/
    /*border-bottom-right-radius: 8px;*/
  }
  .add-event__footer .img-sharp {
    margin-right: 10px;
  }
  .add-event__footer .text-info-reset-password {
    color: white;
    text-align: left;
    font-size: 12px;
    margin-top: 1rem;
  }
  @media (min-width: $breakpoint-sm) {
    .image-and-form {
      display: flex;
      flex-direction: row;
    }
    .form-buttons {
      display: flex;
      justify-content: flex-end;
    }
  }
</style>
